<template>
    <v-card flat :loading="loading">
      <v-list :v-if="currentUser !== null && currentUser.smsCapable" dense style="max-height: 600px; overflow-y: auto;">
            <v-list-item-group>
              <v-list-item
                v-for="(smsConversation) in smsConversationsFiltered"
                :key="smsConversation.id"
                style="display: -webkit-box !important;"
                class="chat-sms-message"
                :to="{ name: 'chats', params: { roomType: 'direct', roomId: smsConversation.id }}"
                active-class="active"
              >
                  <v-list-item-icon style="max-width: 10px !important;">
                      <v-badge
                        color="orange"
                        :value="smsConversation.unread"
                        offset-x="10"
                        offset-y="10"
                      >
                          <span slot="badge"> {{ smsConversation.unread }} </span>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-avatar size="33" v-on="on">
                                <img
                                :class="smsConversation.open ? '' : 'closedAvatar'"
                                :src="smsConversation.to_user.contact_image || smsConversation.to_user.picture_profile"
                                :alt="smsConversation.to_user.chat_username"
                                >
                              </v-avatar>
                            </template>
                            <span>{{ `Using ${smsConversation.didInUse}` }}</span>
                          </v-tooltip>
                      </v-badge>
                  </v-list-item-icon>

                  <v-list-item-content style="margin: 0px !important;min-width: 145px !important;">
                      <v-list-item-title>
                          <span :class="smsConversation.unread > 0 ? ($vuetify.theme.dark ? 'font-weight-bold white--text' : 'font-weight-bold black--text') : 'font-weight-regular'">
                            {{ smsConversation.displayUsername }} <span v-if="!smsConversation.open" class="text-caption font-italic red--text">{{ $t('chat.closed') }}</span>
                          </span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <small :class="smsConversation.unread > 0 ? ($vuetify.theme.dark ? 'font-weight-bold white--text' : 'font-weight-bold black--text') : 'font-weight-regular'">
                          {{ formatLastMessagePreview(smsConversation) }}
                        </small>
                      </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action style="margin: 0px !important;" v-if="chatsWrite && smsConversation.open">
                      <v-menu style="z-index: 999">
                          <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              icon
                              v-on:click.prevent
                              v-bind="attrs"
                              v-on="on"
                              class="context-menu-btn-sms-message"
                          >
                              <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item
                              v-for="(contextMenu, index) in smsConversation.contextMenus(contactsWrite, contactsManagePersonal)"
                              :key="index"
                              style="display: -webkit-box !important;"
                              class="context-menu-item-sms-message"
                              @click="navSmsChatContextMenu(contextMenu, smsConversation)"
                            >
                              <v-list-item-icon>
                              <v-icon :color="contextMenu.color">{{contextMenu.icon}}</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>{{ capitalizeFirstLetter($t(`chat.contextMenu.${contextMenu.key}`)) }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                      </v-menu>
                  </v-list-item-action>
              </v-list-item>
              <!-- Vuetify directive for infinite scroll / pagination -->
              <v-card v-intersect="infiniteScrolling"></v-card>
              <v-progress-circular
                style="margin: 0px !important;min-width: 185px !important;"
                v-show="loading"
                indeterminate
                color="primary"
              ></v-progress-circular>
          </v-list-item-group>
      </v-list>
    </v-card>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MixinChatHelper from '@/mixins/chat/helper'
import MixinChatRoomActions from '@/mixins/chat/room_actions'
const emoji = require('node-emoji')

export default {
  name: 'chat-nav_sms_list',
  mixins: [MixinChatHelper, MixinChatRoomActions],
  created () {
    this.getSmsMessages()
  },
  computed: {
    ...mapGetters({
      buddies: 'users/buddies',
      currentUser: 'chat/authenticatedRocketChatUser',
      smsConversations: 'chat/smsConversations',
      loading: 'chat/smsConversationsLoading',
      chatsWrite: 'permissions/chatsWrite',
      smsFilters: 'chat/smsFilters',
      paginationSms: 'chat/paginationSms',
      smsLoaded: 'chat/smsLoaded',
      filterClosed: 'chat/SmsFilters/closed',
      filterRead: 'chat/SmsFilters/read',
      contactsManagePersonal: 'permissions/contactsManagePersonal',
      contactsWrite: 'permissions/contactsWrite',
      searchText: 'chat/SmsFilters/search'
    }),
    smsConversationsFiltered: function () {
      let filteredList = this.smsConversations
      // Filter by phone numbers the current user own
      if (this.smsFilters?.length > 0) {
        filteredList = filteredList.filter(smsConversation => {
          return this.smsFilters.includes(smsConversation.myConversationDid())
        })
      }
      // Filter by open / close
      filteredList = filteredList.filter(smsConversation => {
        if (this.filterClosed) {
          return smsConversation?.open
        } else {
          return true
        }
      })
      // Filter by unread
      filteredList = filteredList.filter(smsConversation => {
        if (this.filterRead) {
          return smsConversation?.unread > 0
        } else {
          return true
        }
      })
      // Filter by search
      const searchReg = new RegExp(this.searchText?.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i')
      filteredList = filteredList.filter(smsConversation => {
        if (this.searchText) {
          return smsConversation.displayUsername.match(searchReg)
        } else {
          return true
        }
      })
      return filteredList
    }
  },
  methods: {
    ...mapActions({
      getSmsMessages: 'chat/getSmsMessages',
      getMoreSmsMessages: 'chat/getMoreSmsMessages'
    }),
    async infiniteScrolling (entries, observer, isIntersecting) {
      if (isIntersecting && entries.length === 1 && this.smsConversations?.length > 1 && !this.smsLoaded) {
        await this.getMoreSmsMessages()
      }
    },
    formatLastMessagePreview (smsConversation) {
      const baseMessage = smsConversation.formatLastConversationMessagePreview()
      const lastMessageDate = smsConversation.getFriendlyLastMessageDate()
      if (baseMessage) {
        let localizedLastMessageDate
        if (lastMessageDate) {
          if (lastMessageDate.text === 'just now') {
            localizedLastMessageDate = this.$t('chat.date.now')
          } else {
            localizedLastMessageDate = this.$tc(`chat.date.${lastMessageDate.interval.unit}`, lastMessageDate.number)
          }
        } else {
          localizedLastMessageDate = this.$t('chat.date.now')
        }
        return emoji.emojify(baseMessage + localizedLastMessageDate)
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.active {
  color: #1976d2;
}
.closedAvatar {
  filter: brightness(0.5)
}
</style>
